import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { applyPwaUpdate, hasPwaUpdateAvailable, subscribeToPwaUpdateAvailable } from '../../registerPwa';
import { bottomCenterSnackbarStackSx, defaultSnackbarContentSx } from './snackbarStyles';

interface PwaUpdateSnackbarProps {
  stackIndex: number;
}

const PwaUpdateSnackbar = ({ stackIndex }: PwaUpdateSnackbarProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isApplying, setIsApplying] = useState(false);

  useEffect(
    () =>
      subscribeToPwaUpdateAvailable(() => {
        setIsApplying(false);
        setOpen(hasPwaUpdateAvailable());
      }),
    []
  );

  const handleRefresh = () => {
    if (applyPwaUpdate()) {
      setIsApplying(true);
    }
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      message={t('pwaUpdate.message', { defaultValue: 'A new version is available.' })}
      action={
        <Button color="primary" size="small" onClick={handleRefresh} disabled={isApplying}>
          {t('pwaUpdate.action.refresh', { defaultValue: 'Refresh' })}
        </Button>
      }
      slotProps={{
        content: {
          sx: defaultSnackbarContentSx,
        },
      }}
      sx={bottomCenterSnackbarStackSx(stackIndex)}
    />
  );
};

export default PwaUpdateSnackbar;
